export default "__VITE_ASSET__4eXDedTd__"